function findLinkRange(position, value, model) {
    return model.createRange(findBound(position, value, true, model), findBound(position, value, false, model));
}
function findBound(position, value, lookBack, model) {
    let node = position.textNode || (lookBack ? position.nodeBefore : position.nodeAfter);
    let lastNode = null;
    while (node && node.getAttribute('internalLink') == value) {
        lastNode = node;
        node = lookBack ? node.previousSibling : node.nextSibling;
    }
    return lastNode ? model.createPositionAt(lastNode, lookBack ? 'before' : 'after') : position;
}
export { findLinkRange };
